import { render, staticRenderFns } from "./orderScheduling.vue?vue&type=template&id=3644d8ed&scoped=true"
import script from "./orderScheduling.vue?vue&type=script&lang=js"
export * from "./orderScheduling.vue?vue&type=script&lang=js"
import style0 from "./orderScheduling.vue?vue&type=style&index=0&id=3644d8ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644d8ed",
  null
  
)

export default component.exports